import { MapPin } from 'lucide-react';

export function PlacedMapPin() {
  return (
    <div className="interactive-map-placed-marker">
      <span className="interactive-map-placed-marker__halo" aria-hidden="true" />
      <MapPin className="interactive-map-placed-marker__pin" aria-hidden="true" />
    </div>
  );
}
